import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { PortfolioProvider } from '@/context/PortfolioContext';

/** @constant rootElement - The DOM element where the React app will be mounted. */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Could not find root element with id 'root' to mount React app.");
}

/** @constant root - The React root instance. */
const root = createRoot(rootElement);

root.render(
  // Note: React.StrictMode is often added here during development
  // to help identify potential problems in an application.
  // <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <PortfolioProvider>
          <App />
        </PortfolioProvider>
      </QueryClientProvider>
    </HelmetProvider>
  // </React.StrictMode>
);
